module.exports = __webpack_public_path__ + "img/lens-160-plus-00.7a70e528.png";